// Budget app constants + pure utility helpers (no React).

export const CATEGORY_COLORS = {
  Rental: "#E27D60",
  "Car Loan": "#B56B7E",
  Insurance: "#8FB9AA",
  "Phone/Internet": "#6E7A91",
  Groceries: "#E8A87C",
  Fuel: "#C38D9E",
  Dining: "#41B3A3",
  Entertainment: "#E2B35B",
  "Shopping & Clothing": "#D49AC8",
  Payments: "#A88B6A",
  Miscellaneous: "#9AA38F",
};

export const DEFAULT_EXPENSES = {
  Rental: 1800,
  "Car Loan": 400,
  Insurance: 180,
  "Phone/Internet": 130,
  Groceries: 600,
  Fuel: 220,
  Dining: 250,
  Entertainment: 150,
  "Shopping & Clothing": 200,
  Payments: 0,
  Miscellaneous: 100,
};

export const SUMMARY_BAR_COLORS = {
  Income: "#5F7161",
  Expenditure: "#E27D60",
  Savings: "#6B8E23",
};

export const TREND_LINE_COLORS = {
  Income: "#5F7161",
  Expenditure: "#E27D60",
  Savings: "#6B8E23",
};

const CAD = new Intl.NumberFormat("en-CA", {
  style: "currency",
  currency: "CAD",
  maximumFractionDigits: 0,
});

const CAD_COMPACT = new Intl.NumberFormat("en-CA", {
  style: "currency",
  currency: "CAD",
  notation: "compact",
  maximumFractionDigits: 1,
});

export const fmtCAD = (n) => CAD.format(Number.isFinite(n) ? n : 0);
export const fmtCADCompact = (n) => CAD_COMPACT.format(Number.isFinite(n) ? n : 0);

const parseYM = (ym) => ym.split("-").map(Number);

export const monthLabel = (ym) => {
  const [y, m] = parseYM(ym);
  return new Date(y, m - 1, 1).toLocaleString("en-CA", { month: "long", year: "numeric" });
};

export const monthShort = (ym) => {
  const [y, m] = parseYM(ym);
  return new Date(y, m - 1, 1).toLocaleString("en-CA", { month: "short", year: "2-digit" });
};

export const shiftMonth = (ym, delta) => {
  const [y, m] = parseYM(ym);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const currentMonth = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

// Resolve a backend URL that avoids CORS issues when the page is served from a
// www / apex variant of the same domain (e.g. www.mysavio.com vs mysavio.com).
export function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return envUrl || "";
  if (!envUrl) return window.location.origin;
  try {
    const envHost = new URL(envUrl).hostname.replace(/^www\./, "");
    const pageHost = window.location.hostname.replace(/^www\./, "");
    if (envHost && pageHost && envHost === pageHost) {
      return window.location.origin;
    }
  } catch (_) {
    // ignore parse errors and fall through to env url
  }
  return envUrl;
}

export const API = `${resolveBackendUrl()}/api`;
